function createOverlay(image) {
  const existingOverlayWrapper = document.querySelector('.popup-zoom-wrapper');
  if (existingOverlayWrapper) {
    existingOverlayWrapper.remove();
  }

  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  const overlayWrapper = document.createElement('div');
  overlayWrapper.setAttribute('class', 'popup-zoom-wrapper');
  overlayWrapper.appendChild(overlay);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    document.querySelector('.product__media-wrapper').appendChild(overlayWrapper);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function createHoverSquare() {
  const hoverSquare = document.createElement('div');
  hoverSquare.setAttribute('class', 'hover-square');
  document.querySelector('media-gallery[data-desktop-layout=thumbnail_slider]').appendChild(hoverSquare);
  return hoverSquare;
}

const hoverSquare = createHoverSquare();

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;

  // calculate square position
  const squareSize = 400 / 2.0;
  const halfSquare = squareSize / 2;
  const xBounded = Math.min(Math.max(xPosition - halfSquare, 0), image.width - squareSize);
  const yBounded = Math.min(Math.max(yPosition - halfSquare, 0), image.height - squareSize);

  hoverSquare.style.left = `${container.left + xBounded}px`;
  hoverSquare.style.top = `${container.top + yBounded}px`;
  hoverSquare.style.display = 'block';
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);

  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onmouseenter = (event) => {
      hoverSquare.style.display = 'block';
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };

    image.onmousemove = (event) => {
      moveWithHover(image, event, zoomRatio);
    };

    image.onmouseleave = () => {
      overlay.remove();
      hoverSquare.style.display = 'none';
    };
  });
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onmouseenter = (event) => {
      hoverSquare.style.display = 'block';
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2.0);
